import { render, staticRenderFns } from "./Purchasing.vue?vue&type=template&id=63679ef2&scoped=true"
import script from "./Purchasing.vue?vue&type=script&lang=js"
export * from "./Purchasing.vue?vue&type=script&lang=js"
import style0 from "./Purchasing.vue?vue&type=style&index=0&id=63679ef2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63679ef2",
  null
  
)

export default component.exports